module.exports = __webpack_public_path__ + "static/media/wrong-dark.3ebb38f1.png";